import React, { useState } from 'react';
import PregnancyList from './PregnancyList';
import JSSKDetails from './JSSKDetails';

const JSSKServices: React.FC = () => {
  const [selectedPregnancy, setSelectedPregnancy] = useState<any>(null);

  const handlePregnancySelect = (pregnancy: any) => {
    setSelectedPregnancy(pregnancy);
  };

  const handleBack = () => {
    setSelectedPregnancy(null);
  };

  return (
    <>
      {!selectedPregnancy ? (
        <PregnancyList onPregnancySelect={handlePregnancySelect} />
      ) : (
        <JSSKDetails pregnancyData={selectedPregnancy} onBack={handleBack} />
      )}
    </>
  );
};

export default JSSKServices;
export { default as PregnancyList } from './PregnancyList';
export { default as JSSKDetails } from './JSSKDetails';
